var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChos3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedometer-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66666 16.0003C6.66666 10.8457 10.8453 6.66699 16 6.66699M21.9999 10.0003L15.9999 16.0003M29.3333 16.0003C29.3333 23.3641 23.3638 29.3337 16 29.3337C8.63619 29.3337 2.66666 23.3641 2.66666 16.0003C2.66666 8.63653 8.63619 2.66699 16 2.66699C23.3638 2.66699 29.3333 8.63653 29.3333 16.0003ZM17.3333 16.0003C17.3333 16.7367 16.7364 17.3337 16 17.3337C15.2636 17.3337 14.6667 16.7367 14.6667 16.0003C14.6667 15.2639 15.2636 14.667 16 14.667C16.7364 14.667 17.3333 15.2639 17.3333 16.0003Z",
    stroke: "#1C2541",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChos3);
export default __webpack_public_path__ + "static/media/chos3.212a9fe8d925e3e1d6a6223604049563.svg";
export { ForwardRef as ReactComponent };